import React from 'react';
import { graphql } from 'gatsby';
import classnames from 'classnames';
import SanityPortableText from '../SanityPortableText';

import Pancake from './Pancake';
import Container from '../Container';
import Card from '../Card';
import CustomerQuote from '../CustomerQuote';

import './TextSidebar.scss';

const TextSidebar = (props) => {
  const { text, sidebarPancakes, theme, className } = props;

  const doesItStartWithCustomerQuote =
    text.length > 0 && text[0]._type === 'customerQuote';

  return (
    <Pancake
      className={classnames(
        'TextSidebar',
        className,
        doesItStartWithCustomerQuote
          ? 'TextSidebarStartWithCustomerQuote'
          : undefined
      )}
      theme={theme}
    >
      <Container>
        <div className="TextSidebarGrid">
          <aside>
            {sidebarPancakes.map((pancake) => {
              if (pancake._type === 'blocks') {
                return (
                  <Card theme="LightBlue" shadowLevel="Low">
                    <SanityPortableText blocks={pancake._rawPancakeText} />
                  </Card>
                );
              }
              if (pancake._type === 'customerQuote') {
                return (
                  <Card theme="Light" shadowLevel="Low" paddingSize="Double">
                    <CustomerQuote author={pancake.author}>
                      {pancake.quote}
                    </CustomerQuote>
                  </Card>
                );
              }
            })}
          </aside>
          <div className="TextSidebarContent">
            <SanityPortableText blocks={text} />
          </div>
        </div>
      </Container>
    </Pancake>
  );
};

export const query = graphql`
  fragment SanityPancakeTextSidebar on SanityTextSidebar {
    _key
    _type
    _rawText(resolveReferences: { maxDepth: 1000 })
    theme
    sidebarPancakes {
      ... on SanityBlocks {
        _key
        _type
        _rawPancakeText(resolveReferences: { maxDepth: 1000 })
      }
      ... on SanityCustomerQuote {
        _key
        _type
        quote
        showAuthorsCompany
        showAuthorsPicture
        author {
          name
          jobtitle
          image {
            ...ImageWithPreview
          }
          company {
            name
          }
        }
      }
    }
  }
`;

export default TextSidebar;
